var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeLatest } from "redux-saga/effects";
import logger from "../../logger";
import { showAlert } from "../../utils/alert/alert.utils";
import * as authActions from "../auth/auth.actions";
import * as enabledAccountActions from "./enabledAccount.actions";
import * as enabledAccountApi from "./enabledAccount.api";
function getEnabledAccountsStartFlow(action) {
    var _a, userId, search, onSuccess, onFailure, response, result, unknownError_1, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, userId = _a.userId, search = _a.search, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(enabledAccountApi.getEnabledAccounts, { userId: userId, search: search })];
            case 2:
                response = _b.sent();
                result = response.data.data;
                return [4 /*yield*/, put(enabledAccountActions.getEnabledAccountsSucceeded.getAction({ result: result }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(result);
                return [3 /*break*/, 6];
            case 4:
                unknownError_1 = _b.sent();
                error = unknownError_1;
                logger.logError({ error: error });
                showAlert({ type: "error", error: error });
                return [4 /*yield*/, put(enabledAccountActions.getEnabledAccountsFailed.getAction({ error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function getEnabledAccountsCountStartFlow(action) {
    var _a, userId, onSuccess, onFailure, response, count, unknownError_2, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, userId = _a.userId, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(enabledAccountApi.getEnabledAccountsCount, { userId: userId })];
            case 2:
                response = _b.sent();
                count = response.data.data.count;
                return [4 /*yield*/, put(enabledAccountActions.getEnabledAccountsCountSucceeded.getAction({
                        count: count,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(count);
                return [3 /*break*/, 6];
            case 4:
                unknownError_2 = _b.sent();
                error = unknownError_2;
                logger.logError({ error: error });
                showAlert({ type: "error", error: error });
                return [4 /*yield*/, put(enabledAccountActions.getEnabledAccountsCountFailed.getAction({ error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function addEnabledAccountStartFlow(action) {
    var _a, userId, enabledAccountId, onSuccess, onFailure, unknownError_3, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, userId = _a.userId, enabledAccountId = _a.enabledAccountId, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(enabledAccountApi.addEnabledAccount, userId, enabledAccountId)];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(enabledAccountActions.addEnabledAccountSucceeded.getAction({
                        userId: userId,
                        enabledAccountId: enabledAccountId,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 6];
            case 4:
                unknownError_3 = _b.sent();
                error = unknownError_3;
                logger.logError({ error: error });
                showAlert({ type: "error", error: error });
                return [4 /*yield*/, put(enabledAccountActions.addEnabledAccountFailed.getAction({ error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function removeEnabledAccountStartFlow(action) {
    var _a, userId, enabledAccountId, onSuccess, onFailure, unknownError_4, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, userId = _a.userId, enabledAccountId = _a.enabledAccountId, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(enabledAccountApi.removeEnabledAccount, userId, enabledAccountId)];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(enabledAccountActions.removeEnabledAccountSucceeded.getAction({
                        userId: userId,
                        enabledAccountId: enabledAccountId,
                    }))];
            case 3:
                _b.sent();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
                return [3 /*break*/, 6];
            case 4:
                unknownError_4 = _b.sent();
                error = unknownError_4;
                logger.logError({ error: error });
                showAlert({ type: "error", error: error });
                return [4 /*yield*/, put(enabledAccountActions.removeEnabledAccountFailed.getAction({ error: error }))];
            case 5:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
// Switching the active account mints a brand-new session token for the target
// account — this is functionally a re-login, not a plain entity mutation. On
// success it hands the new tokens to the auth module (setAccessTokensWithoutSideEffects),
// which is the same module every other sign-in/token-refresh flow in this app uses to
// swap tokens; it does not show its own alert, so failures here still surface via the
// showAlert below.
function useEnabledAccountStartFlow(action) {
    var _a, userId, enabledAccountId, onSuccess, onFailure, response, tokens, unknownError_5, error;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, userId = _a.userId, enabledAccountId = _a.enabledAccountId, onSuccess = _a.onSuccess, onFailure = _a.onFailure;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, call(enabledAccountApi.useEnabledAccount, userId, enabledAccountId)];
            case 2:
                response = _b.sent();
                tokens = response.data.data;
                return [4 /*yield*/, put(enabledAccountActions.useEnabledAccountSucceeded.getAction(tokens))];
            case 3:
                _b.sent();
                return [4 /*yield*/, put(authActions.setAccessTokensWithoutSideEffectsStart.getAction({
                        accessToken: tokens.accessToken,
                        refreshToken: tokens.refreshToken,
                    }))];
            case 4:
                _b.sent();
                if (!onSuccess) return [3 /*break*/, 6];
                return [4 /*yield*/, call(onSuccess, tokens)];
            case 5:
                _b.sent();
                _b.label = 6;
            case 6: return [3 /*break*/, 9];
            case 7:
                unknownError_5 = _b.sent();
                error = unknownError_5;
                logger.logError({ error: error });
                showAlert({ type: "error", error: error });
                return [4 /*yield*/, put(enabledAccountActions.useEnabledAccountFailed.getAction({ error: error }))];
            case 8:
                _b.sent();
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(error);
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(enabledAccountActions.getEnabledAccountsStart.type, getEnabledAccountsStartFlow)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(enabledAccountActions.getEnabledAccountsCountStart.type, getEnabledAccountsCountStartFlow)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(enabledAccountActions.addEnabledAccountStart.type, addEnabledAccountStartFlow)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(enabledAccountActions.removeEnabledAccountStart.type, removeEnabledAccountStartFlow)];
            case 4:
                _a.sent();
                return [4 /*yield*/, takeLatest(enabledAccountActions.useEnabledAccountStart.type, useEnabledAccountStartFlow)];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
